import { ArrowLeftOutlined } from '@ant-design/icons';
import { Alert, Button, Card, Col, Form, Radio, Row, Select, Checkbox } from 'antd';
import React, { useState } from 'react'
import { FaQuestionCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';
// import PageHeading from '../../../../components/common/PageHeading';
import RightBar from '../../../../components/common/RightBar';
import { WorkOrdersRightBar } from '../WordOrdersData';
import './CustomizeWorkOrder.css'

const CustomizeWorkOrderPage = () => {
    const [showEdit, setShowEdit] = useState(true)

    const [dashboardMetricsEditt, setDashboardMetricsEditt] = useState(true)
    const [inputFields, setInputFields] = useState(false)

    const [metric1, setMetric1] = useState("Unassigned Resident Requested");
    const [metric2, setMetric2] = useState("Unassigned Internal");
    const [metric3, setMetric3] = useState("Resident Requested Without Action In 2 Or More Days");
    const [metric4, setMetric4] = useState("Internal Without Action In 7 Or More Days");

    const [stickyFilters, setStickyFilters] = useState(false);

    const editBtn = () => {
        setShowEdit(false)
    }
    const saveBtn = () => {
        setShowEdit(true)
    }
    const cancelBtn = () => {
        setShowEdit(true)
    }
    const saveDashboardMetricsBtn = () => {
        setDashboardMetricsEditt(true);
        setInputFields(false)
    }
    const cancelDashboardMetricsBtn = () => {
        setDashboardMetricsEditt(true);
        setInputFields(false)
    }
    const dashboardMetricsEdit = () => {
        setDashboardMetricsEditt(false);
        setInputFields(true);
    }
    const optionShow = [
        {
            value: 'Unassigned Resident Requested'

        },
        {
            value: 'Unassigned Internal'
        },
        {
            value: 'Resident Requested Without Action In 2 Or More Days'
        },
        {
            value: 'Internal Without Action In 7 Or More Days'
        },
    ]
    const onCheckboxChange = (e) => {
        console.log(`checked = ${e.target.checked}`);
        setStickyFilters(e.target.checked);
    };

    return (
        <div className="CustomizeWorkOrder">

            <Row>
                <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div className='arrow-styling'>
                        <ArrowLeftOutlined />
                    </div>
                    <Link to="/maintenance/work-orders">Back to search results</Link>
                </Col>


            </Row>
            <p style={{fontSize: '26px', margin: '15px 0px'}}>Customize My Work Orders Page</p>
            {/* <PageHeading heading="Customize My Work Orders Page" /> */}

            <Row gutter={[14, 14]}>

                <Col span={24}>
                    <Alert
                        showIcon
                        description="We're Making it Easier to Filter the Work Orders Page. "
                        action={
                            <Button size="small" >
                                FEEDBACK
                            </Button>
                        }
                    />
                </Col>

                <Col span={24}>
                    <Card title="My Dashboard Metrics" extra={<a onClick={dashboardMetricsEdit}>{dashboardMetricsEditt && "Edit"}</a>}>
                        <span>Customize your dashboard metrics using any of your saved filters.</span>

                        <Form layout='vertical' style={{ display: 'flex', marginTop: '20px' }}>

                            <Col span={6}>
                                <Form.Item label="1st Metric">
                                    {
                                        inputFields ?
                                            <Select defaultValue={metric1} options={optionShow} onChange={(value) => setMetric1(value)} /> :
                                            <span span={2}>{metric1}</span>
                                    }
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="2nd Metric">

                                    {
                                        inputFields ?
                                            <Select defaultValue={metric2} options={optionShow} onChange={(value) => setMetric2(value)} /> :
                                            <span span={2}>{metric2}</span>

                                    }
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="3rd Metric">
                                    {
                                        inputFields ?
                                            <Select defaultValue={metric3} options={optionShow} onChange={(value) => setMetric3(value)} /> :
                                            <span span={2}>{metric3}</span>
                                    }
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="4th Metric">
                                    {
                                        inputFields ?
                                            <Select defaultValue={metric4} options={optionShow} onChange={(value) => setMetric4(value)} /> :
                                            <span span={2}>{metric4}</span>
                                    }
                                </Form.Item>
                            </Col>

                        </Form>
                        {!dashboardMetricsEditt && (
                            <div className="form-action page-actions-container">
                                <Button type="primary" onClick={saveDashboardMetricsBtn}>
                                    Save
                                </Button>
                                <Button onClick={cancelDashboardMetricsBtn}>Cancel</Button>
                            </div>
                        )}
                    </Card>

                </Col>

                <Col span={24}>
                    <Card title="My Saved Filters">
                        <Col style={{ display: 'flex', flexDirection: 'column' }}>
                            <span>To create new saved filters:</span>
                            <span>1. While on the Work Orders page, apply any filters you want to include.</span>
                            <span>2. Click the “Saved Filters” field and select “Create Saved Filter from Current Filters” at the bottom of the dropdown list.</span>
                            <span>These saved filters are only visible to you.</span>

                        </Col>

                        <Row style={{ border: '1px solid gray', borderBottom: 'none', borderRadius: '5px', margin: '12px 0px' }}>
                            <Col span={24} className="save-filters-grid" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Col span={22}>
                                    <h1>Unassigned Resident Requested</h1>
                                    <Col style={{ display: 'flex' }}>
                                        <Radio.Group
                                            style={{
                                                margin: '10px 5px'
                                            }}
                                        >
                                            <Radio.Button className='first-grid-tab'>Work Order Type</Radio.Button>
                                            <Radio.Button value="middle" onClick={(e) => e.preventDefault()}>Resident</Radio.Button>
                                        </Radio.Group>
                                        <Radio.Group
                                            style={{
                                                margin: '10px 5px'
                                            }}
                                        >
                                            <Radio.Button className='first-grid-tab'>Status</Radio.Button>
                                            <Radio.Button value="middle">Open</Radio.Button>
                                        </Radio.Group>
                                        <Radio.Group
                                            style={{
                                                margin: '10px 5px'
                                            }}
                                        >
                                            <Radio.Button className='first-grid-tab'>Unassigned</Radio.Button>
                                            <Radio.Button value="middle">True</Radio.Button>
                                        </Radio.Group>
                                    </Col>

                                </Col>
                                <Col span={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <a href='#'><span>View</span></a>
                                </Col>
                            </Col>

                            <Col span={24} className="save-filters-grid" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Col span={22}>
                                    <h1>Unassigned Internal</h1>
                                    <Col style={{ display: 'flex' }}>
                                        <Radio.Group
                                            style={{
                                                margin: '10px 5px'
                                            }}
                                        >
                                            <Radio.Button className='first-grid-tab'>Work Order Type</Radio.Button>
                                            <Radio.Button value="middle">Resident</Radio.Button>
                                        </Radio.Group>
                                        <Radio.Group
                                            style={{
                                                margin: '10px 5px'
                                            }}
                                        >
                                            <Radio.Button className='first-grid-tab'>Status</Radio.Button>
                                            <Radio.Button value="middle">Open</Radio.Button>
                                        </Radio.Group>
                                        <Radio.Group
                                            style={{
                                                margin: '10px 5px'
                                            }}
                                        >
                                            <Radio.Button className='first-grid-tab'>Unassigned</Radio.Button>
                                            <Radio.Button value="middle">True</Radio.Button>
                                        </Radio.Group>
                                    </Col>

                                </Col>
                                <Col span={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <a href='#'><span>View</span></a>
                                </Col>
                            </Col>

                            <Col span={24} className="save-filters-grid" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Col span={22}>
                                    <h1>Resident Requested Without Action In 2 Or More Days</h1>
                                    <Col style={{ display: 'flex' }}>
                                        <Radio.Group
                                            style={{
                                                margin: '10px 5px'
                                            }}
                                        >
                                            <Radio.Button className='first-grid-tab'>Work Order Type</Radio.Button>
                                            <Radio.Button value="middle">Resident</Radio.Button>
                                        </Radio.Group>
                                        <Radio.Group
                                            style={{
                                                margin: '10px 5px'
                                            }}
                                        >
                                            <Radio.Button className='first-grid-tab'>Status</Radio.Button>
                                            <Radio.Button value="middle">Open</Radio.Button>
                                        </Radio.Group>

                                        <Radio.Group
                                            style={{
                                                margin: '10px 5px'
                                            }}
                                        >
                                            <Radio.Button className='first-grid-tab'>Last Action</Radio.Button>
                                            <Radio.Button value="middle">2 days ago</Radio.Button>
                                        </Radio.Group>
                                        <Radio.Group
                                            style={{
                                                margin: '10px 5px'
                                            }}
                                        >
                                            <Radio.Button className='first-grid-tab'>Unassigned</Radio.Button>
                                            <Radio.Button value="middle">True</Radio.Button>
                                        </Radio.Group>
                                    </Col>

                                </Col>
                                <Col span={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <a href='#'><span>View</span></a>
                                </Col>
                            </Col>

                            <Col span={24} className="save-filters-grid" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Col span={22}>
                                    <h1>Internal Without Action In 7 Or More Days</h1>
                                    <Col style={{ display: 'flex' }}>
                                        <Radio.Group
                                            style={{
                                                margin: '10px 5px'
                                            }}
                                        >
                                            <Radio.Button className='first-grid-tab'>Work Order Type</Radio.Button>
                                            <Radio.Button value="middle">Resident</Radio.Button>
                                        </Radio.Group>
                                        <Radio.Group
                                            style={{
                                                margin: '10px 5px'
                                            }}
                                        >
                                            <Radio.Button className='first-grid-tab'>Status</Radio.Button>
                                            <Radio.Button value="middle">Open</Radio.Button>
                                        </Radio.Group>
                                        <Radio.Group
                                            style={{
                                                margin: '10px 5px'
                                            }}
                                        >
                                            <Radio.Button className='first-grid-tab'>Last Action</Radio.Button>
                                            <Radio.Button value="middle">7 days ago</Radio.Button>
                                        </Radio.Group>
                                        <Radio.Group
                                            style={{
                                                margin: '10px 5px'
                                            }}
                                        >
                                            <Radio.Button className='first-grid-tab'>Unassigned</Radio.Button>
                                            <Radio.Button value="middle">True</Radio.Button>
                                        </Radio.Group>
                                    </Col>

                                </Col>
                                <Col span={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <a href='#'><span>View</span></a>
                                </Col>
                            </Col>
                        </Row>


                    </Card>

                </Col>


                <Col span={24}>
                    <Card title="Page Settings" extra={<a onClick={editBtn}>{showEdit && "Edit"}</a>}>
                        <span>With Sticky Filters on, the <a href="#">Work Orders page</a> always applies your most recently selected filters (and is user-specific).</span>
                        <Col span={4} style={{
                            margin: '10px 15%', display: 'flex',
                            justifyContent: 'space-around', alignItems: 'center'
                        }}>
                            <p style={{ color: 'gray' }}>Sticky Filters</p>
                            {!showEdit && (
                                <>
                                    <Checkbox checked={stickyFilters} onChange={onCheckboxChange} />

                                    <FaQuestionCircle size={16} className="circled-question" />
                                </>
                            )}
                            {showEdit && <p style={{ marginRight: '40px' }}>{stickyFilters ? "Yes" : "No"}</p >}
                        </Col>
                        {!showEdit && (
                            <div className="form-action page-actions-container">
                                <Button type="primary" onClick={saveBtn}>
                                    Save
                                </Button>
                                <Button onClick={cancelBtn}>Cancel</Button>
                            </div>
                        )}
                    </Card>

                </Col>

            </Row>


            <div className="RightSidebar">
                <RightBar RightBarData={WorkOrdersRightBar} />
            </div>
        </div>
    )
}

export default CustomizeWorkOrderPage;